<!-- <nav-bar></nav-bar> moved to MainLayout -->
<router-outlet class="router-padding">
</router-outlet>

<app-loader scope="screen"></app-loader>

<p-toast position="top-right" [preventOpenDuplicates]="true" [preventDuplicates]="true"></p-toast>